import React from 'react';
import PropTypes from 'prop-types';
import { LuArrowDownLeft, LuArrowUpRight } from 'react-icons/lu';
import { CARGO_DIRECTION } from '../../../utils/companyShipments';

// Kargo ekranlarının ortak görsel parçaları.

export const DIRECTION_STYLES = {
  [CARGO_DIRECTION.INCOMING]: {
    icon: LuArrowDownLeft,
    tile: 'tw-bg-emerald-500/10 tw-text-emerald-600 dark:tw-bg-emerald-400/10 dark:tw-text-emerald-300',
    badge: 'success',
  },
  [CARGO_DIRECTION.OUTGOING]: {
    icon: LuArrowUpRight,
    tile: 'tw-bg-sky-500/10 tw-text-sky-600 dark:tw-bg-sky-400/10 dark:tw-text-sky-300',
    badge: 'info',
  },
};

/** Selected status chip / button colours by status tone. */
export const STATUS_TONES = {
  neutral: 'tw-border-slate-400/50 tw-bg-slate-500/10 tw-text-slate-800 dark:tw-text-slate-100',
  info: 'tw-border-sky-500/50 tw-bg-sky-500/10 tw-text-sky-800 dark:tw-text-sky-200',
  success: 'tw-border-emerald-500/50 tw-bg-emerald-500/10 tw-text-emerald-800 dark:tw-text-emerald-200',
  danger: 'tw-border-rose-500/50 tw-bg-rose-500/10 tw-text-rose-800 dark:tw-text-rose-200',
};

/** Timeline dot colours by status tone. */
export const STATUS_DOTS = {
  neutral: 'tw-bg-slate-400',
  info: 'tw-bg-sky-500',
  success: 'tw-bg-emerald-500',
  danger: 'tw-bg-rose-500',
};

export const FORM_SECTION = 'tw-space-y-4 tw-rounded-[1.25rem] tw-border tw-border-slate-200/80 tw-bg-slate-50/60 tw-p-4 dark:tw-border-white/10 dark:tw-bg-white/[0.02]';

export const SECTION_TITLE = 'tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-slate-400 dark:tw-text-slate-500';

/** Square tile with the parcel's direction arrow (green: incoming, blue: outgoing). */
export const DirectionTile = ({ direction, size = 'md', title }) => {
  const style = DIRECTION_STYLES[direction] || DIRECTION_STYLES[CARGO_DIRECTION.OUTGOING];
  const Icon = style.icon;
  const box = size === 'lg' ? 'tw-h-11 tw-w-11 tw-rounded-2xl' : 'tw-h-10 tw-w-10 tw-rounded-xl';
  return (
    <span title={title} className={`tw-grid tw-shrink-0 tw-place-items-center ${box} ${style.tile}`}>
      <Icon aria-hidden="true" className="tw-h-5 tw-w-5" />
    </span>
  );
};

DirectionTile.propTypes = { direction: PropTypes.string, size: PropTypes.oneOf(['md', 'lg']), title: PropTypes.string };
